"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatTitleCase;
exports.formatTitleCaseWithExclusions = formatTitleCaseWithExclusions;
var _isString = _interopRequireDefault(require("lodash/isString"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapExclusionsWithSeparators = function mapExclusionsWithSeparators(separators) {
  var exclusions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var mappedStrings = [];
  exclusions.slice().forEach(function (string) {
    separators.forEach(function (separator) {
      mappedStrings.push("".concat(separator).concat(string).concat(separator));
    });
  });
  return mappedStrings;
};
function formatTitleCase(input) {
  var separators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!(0, _isString["default"])(input)) {
    return input;
  }
  var numSeparators = separators.length;
  var output = input.toLowerCase();
  var i = 0;
  var _loop = function _loop() {
    var separator = separators[i];
    output = separator && output.indexOf(separator) > -1 ? output.split(separator).map(function (word) {
      return word && separator !== word ? word.replace(word[0], word[0].toUpperCase()) : word;
    }).join(separator) : "".concat(output.replace(output[0], output[0].toUpperCase()));
  };
  for (; i < numSeparators; i += 1) {
    _loop();
  }
  return output;
}
function formatTitleCaseWithExclusions(value) {
  var separators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [' '];
  var exclusions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!value || !(0, _isString["default"])(value)) {
    return '';
  }
  var separatedExclusions = mapExclusionsWithSeparators(separators, exclusions);
  var text = formatTitleCase(value, separators, separatedExclusions);
  var i = 0;
  var exclusionsLength = separatedExclusions.length;

  // format exclusion strings that should not be capitalized
  for (; i < exclusionsLength; i++) {
    var exclusion = separatedExclusions[i];
    var ignoreRegExp = new RegExp("".concat(exclusion), 'gi');
    text = text.replace(ignoreRegExp, exclusion);
  }
  return text;
}